export const seo = {
  home: {
    title: 'Regina Nigma | Web Products, MVPs & Automation',
    description:
      'MVPs, SaaS platforms, and business automation shipped with clear logic and predictable delivery.',
    ogTitle: 'Regina Nigma | Web Products, MVPs & Automation',
    ogDescription:
      'MVPs, SaaS platforms, and business automation shipped with clear logic and predictable delivery.',
  },
  person: {
    '@id': 'https://regina-nigma.com/#regina-nigma',
    name: 'Regina Nigma',
    url: 'https://regina-nigma.com',
    image: 'https://regina-nigma.com/my-photo.jpeg',
    jobTitle: 'Senior Software Engineer',
    description:
      'MVPs, SaaS platforms, and internal tools — built with clear logic, realistic scope, and hands-on execution.',
    sameAs: [
      'https://www.linkedin.com/in/reginanigmatullina/',
      'https://github.com/regizum',
    ],
    knowsAbout: [
      'MVP development',
      'SaaS platforms',
      'Internal tools',
      'Business automation',
      'Web applications',
      'Dashboards',
      'Role-based access control',
      'Payments',
    ],
  },
  contact: {
    title: 'Book a Call | Regina Nigma',
    description:
      'Schedule a 30-minute call to discuss your product, automation needs, or next release.',
    ogTitle: 'Book a Call | Regina Nigma',
    ogDescription:
      'Schedule a 30-minute call to discuss your product, automation needs, or next release.',
  },
  portfolio: {
    title: 'Selected Work | Regina Nigma',
    description:
      'A selection of product and web app work across SaaS, dashboards, and automation.',
    ogTitle: 'Selected Work | Regina Nigma',
    ogDescription:
      'A selection of product and web app work across SaaS, dashboards, and automation.',
  },
  privacy: {
    title: 'Privacy Policy | Regina Nigma',
    description:
      'How information is handled when you visit this website or schedule a call.',
    ogTitle: 'Privacy Policy | Regina Nigma',
    ogDescription:
      'How information is handled when you visit this website or schedule a call.',
  },
  terms: {
    title: 'Terms & Conditions | Regina Nigma',
    description:
      'General terms for using this website and scheduling services.',
    ogTitle: 'Terms & Conditions | Regina Nigma',
    ogDescription:
      'General terms for using this website and scheduling services.',
  },
};
